module.exports = __webpack_public_path__ + "img/Undo-icon.b14efb60.svg";